<template>
  <in-viewport>
    <div class="about-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <border-box slot="content">
          <h3 class="about-section__header" v-html="title"/>
          <arrow-link :href="titleAuthorLink" big>
            <span v-html="titleAuthor"/>
          </arrow-link>
          <div class="about-section__content" v-html="content"/>
        </border-box>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'
import ArrowLink from '@/components/ArrowLink'

export default {
  components: {
    BaseLayout,
    BorderBox,
    ArrowLink
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleAuthor: {
      type: String,
      default: ''
    },
    titleAuthorLink: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .about-section {
    &__header{
      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
      }
    }

    &__content {
      @include text;
      @include vertical-space((top: 1, bottom: 1), padding);
      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
      }

      /deep/ p:not(:last-child) {
        @include vertical-space((bottom: 1));
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/About/AboutSection.vue